import React, { useState, useEffect } from 'react';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import { facebookLogout, getFacebookUrl} from 'utils/api';
//import { toast } from 'react-toastify';
import { logout } from 'redux/modules/auth/action';
import Loader from 'components/Loader';

function Integrations({ history, logout }) {
    const [userData, setUserData] = useState('');
    const [loadingFacebook, setFacebookLoading] = useState(true);

    useEffect(() => {
        getUserDataFromFacebook();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

   const getUserDataFromFacebook = async () => {
    setFacebookLoading(true);
        try {
            let facebookUrl = await getFacebookUrl();
            if (facebookUrl.hasOwnProperty('id')) {
                setUserData(facebookUrl);
            } else if (facebookUrl.hasOwnProperty('url')) {
                setUserData(facebookUrl);
            } else {
                console.log('Error: no url or id have found')
            }
            setFacebookLoading(false);
        } catch (err) {
            /*if(err.code === "ACCESS_DENIED") {
                logout();
                history.push('/sign_in');
            }*/
            setFacebookLoading(false);
        }
    }

    const logoutHandler = async () => {
        const params = {
            accountId: userData.id
        }
        const logoutUrl = await facebookLogout(params);
        window.location.assign(logoutUrl.url);
    }

    return (
        <div className="account-card ">
            <div className="mt-2 d-flex align-items-center justify-content-between flex-nowrap" style={{height: '35px'}}>
                <h4>Facebook</h4>
                {loadingFacebook ? (
                    <div className="flex-centered" style={{ minWidth: '110px' }}>
                        {/*<i className="fa fa-spinner fa-spin" />*/}
                        <Loader small/>
                    </div>
                ) : (
                    userData.id ? (
                        <Button
                            onClick={() => logoutHandler()}
                            style={{ backgroundColor: '#4267B2', minWidth: '110px' }}
                            className=" btn btn-info target_input-btn"
                        >
                            Logout
                        </Button>
                    ): (
                        <b>Non Authenticated</b>
                    )
                )}
            </div>
        </div>
    );
}

const mapStateFromProps = ({ auth }) => ({
    auth,
});

export default connect(mapStateFromProps, { logout })(Integrations);
